import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteEditarRoutingModule } from './central-cliente-editar-routing.module';
import { CentralClienteEditarComponent } from './central-cliente-editar.component';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { ToggleButtonModule } from 'primeng/togglebutton';


@NgModule({
  declarations: [
    CentralClienteEditarComponent
  ],
  imports: [
    CommonModule,
    CentralClienteEditarRoutingModule,
    FormsModule,
    DividerModule,
    ProgressSpinnerModule,
    InputTextModule,
    MessagesModule,
    ButtonModule,
    InputMaskModule,
    InputSwitchModule,
    TabViewModule,
    TableModule,
    ConfirmDialogModule,
    DropdownModule,
    ToggleButtonModule
  ],
  providers: [ConfirmationService]
})
export class CentralClienteEditarModule { }
